import { IdentityService } from 'api/generated/services/IdentityService';
import { UseMutationOptions, useMutation } from 'react-query';

export type IdentityUsersTwoFactorSubmitInput = {
  userId: number;
  requestBody?: string;
};

export const useIdentityUsersTwoFactorSubmitMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof IdentityService.postIdentityUsersTwoFactorSubmit>>,
      unknown,
      {
        input: IdentityUsersTwoFactorSubmitInput;
      },
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ input: input }) => IdentityService.postIdentityUsersTwoFactorSubmit(input.userId, input.requestBody),
    options
  );
